import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Locale = 'en' | 'ar';

export interface LanguageState {
  locale: Locale;
  direction: 'ltr' | 'rtl';
}

const initialState: LanguageState = {
  locale: 'en', // English is default
  direction: 'ltr',
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Locale>) => {
      state.locale = action.payload;
      state.direction = action.payload === 'ar' ? 'rtl' : 'ltr';
      // Persist to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem('locale', action.payload);
        document.documentElement.setAttribute('lang', action.payload);
        document.documentElement.setAttribute('dir', state.direction);
      }
    },
    toggleLanguage: (state) => {
      const newLocale = state.locale === 'en' ? 'ar' : 'en';
      state.locale = newLocale;
      state.direction = newLocale === 'ar' ? 'rtl' : 'ltr';
      // Persist to localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem('locale', newLocale);
        document.documentElement.setAttribute('lang', newLocale);
        document.documentElement.setAttribute('dir', state.direction);
      }
    },
    initializeLanguage: (state) => {
      if (typeof window !== 'undefined') {
        const savedLocale = localStorage.getItem('locale') as Locale | null;
        const locale = savedLocale || 'en'; // Default to English
        state.locale = locale;
        state.direction = locale === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.setAttribute('lang', locale);
        document.documentElement.setAttribute('dir', state.direction);
      }
    },
  },
});

export const { setLanguage, toggleLanguage, initializeLanguage } = languageSlice.actions;
export default languageSlice.reducer;

